var uiBreakdown = {
	table: {
		caption: "Ripartizioni",
		weight: "Peso %",
		name: "Nome",
		noItems: "Nessun risultato trovato"
	},
	chart: {
		counting: "Breakdowns",
		topPositions: "Top positions",
		others: "Altro"
	}
};
var it = {
	uiBreakdown: uiBreakdown
};

export { it as default, uiBreakdown };
